var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNike(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.973,
    height: 19.785,
    viewBox: "0 0 54.973 19.785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nike",
    transform: "translate(-277 -2140)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nike-4",
    transform: "translate(253.71 2070.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6399",
    "data-name": "Path 6399",
    d: "M30.332,69.931c-3.577,4.2-7.007,9.411-7.041,13.3a4.61,4.61,0,0,0,1.576,3.713,7.647,7.647,0,0,0,5.164,1.89A19.858,19.858,0,0,0,37.2,86.994c3.387-1.355,40.833-17.616,40.833-17.616.361-.181.294-.407-.159-.294-.182.046-40.765,11.044-40.765,11.044a8.968,8.968,0,0,1-2.362.338c-3.119.018-5.894-1.713-5.872-5.361a11.964,11.964,0,0,1,1.458-5.174Z",
    transform: "translate(0)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNike);
export default __webpack_public_path__ + "static/media/Nike.1dd9b7bf3819f8db982e904ba7ad7133.svg";
export { ForwardRef as ReactComponent };